import React, { Component } from "react";
import { GET_RC_EXCEL_LIST, LOGIN_TYPE_ADMIN, SERVICE10_TEXT, SERVICE37_TEXT, SERVICE38_TEXT } from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
import { DateRangePicker, Dropdown, Alert } from 'rsuite';
//import { NavLink } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import $ from "jquery";
import UnAuthorised from "./UnAuthorised";
import Header from "./include/Header";

const moment = require('moment-timezone');
const FileDownload = require('js-file-download');


class RCExcelList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      rcexcelDownloadData: [],
      isloading: true,
      crTab:0
    };
  }

  componentDidMount() {
    let bbuserid = this.props.match.params.someid;
    this.loadRcexcelDownloadData(bbuserid);
  }

  loadRcexcelDownloadData(bbuserid) {
    Apihelpers.getdataresponse(GET_RC_EXCEL_LIST + bbuserid).then(res => {
      if (res.data.status === true) {
        this.setState({
          rcexcelDownloadData: res.data.data,
          isloading: false
        });
      }
      else {
        this.setState({
          rcexcelDownloadData: res.data.data,
          isloading: false
        });
      }
    }).catch(function (error) {
      console.log('error.......',error);
      Alert.error("Something is wrong...");
      $('.loader').css('display', 'none');
    });
  }

  downloadRCFileResponse = (download_url, type, processType) => {
    //console.log('download_url', download_url);
    var folder = '';
    if(processType === 'RC' && type === 'output') {
      folder = "output-rcfile/";
      download_url = download_url.split('/')[1];
    }
    if(processType === 'RC' && type === 'input') {
      folder = "input-rcfile/";
      download_url = download_url.split('/')[1];
    }
    if(processType === 'CHALLAN' && type === 'output') {
      folder = "output-rcfile/";
      download_url = download_url.split('/')[1];
    }
    if(processType === 'CHALLAN' && type === 'input') {
      folder = "input-rcfile/";
      download_url = download_url.split('/')[1];
    }
    if(processType === 'MOBILE' && type === 'output') {
      folder = "output-rcfile/";
      download_url = download_url.split('/')[1];
    }
    if(processType === 'MOBILE' && type === 'input') {
      folder = "input-rcfile/";
      download_url = download_url.split('/')[1];
    }

    Apihelpers.downloadFileresponse(folder + download_url+'?type='+processType).then(res => {
      FileDownload(res.data, download_url);
    }).catch((err) => {
      console.log(err);
    });
  }

  tabClick = (index) => {
    this.setState({crTab:index})
  }

  renderList = (processType) => {
    return(
      <div className="table-responsive bulk-rc-uploaded-file-list">
      <table className="table">
        <tbody>
          <tr>
            <th>Date</th>
            <th>Input</th>
            {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN?<th>Input Time</th>:""}
            {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN?<th>Output Time</th>:""}
            <th>Count</th>
            <th>Output</th>
            <th style={{width:'125px'}}>Download</th>
          </tr>
          {this.state.rcexcelDownloadData.length > 0 ?
            this.state.rcexcelDownloadData.map((singlercexcelDownloadData, index) => {
              if(singlercexcelDownloadData.process_type !== processType) {
                return;
              }
              var gmtDateTime = moment.utc(singlercexcelDownloadData.created_at, "YYYY-MM-DD HH:mm:ss")
              var gmtDateTimeProcessStart = moment.utc(singlercexcelDownloadData.process_start_at, "YYYY-MM-DD HH:mm:ss")
              var gmtDateTimeProcessEnd = moment.utc(singlercexcelDownloadData.process_end_at, "YYYY-MM-DD HH:mm:ss")
              var localIST = gmtDateTime.utcOffset('+05:30').format('DD-MM-YYYY HH:mm:ss')
              var localISTProcessStart = gmtDateTimeProcessStart.utcOffset('+05:30').format('DD-MM-YYYY HH:mm:ss')
              var localISTProcessEnd = gmtDateTimeProcessEnd.utcOffset('+05:30').format('DD-MM-YYYY HH:mm:ss')
              if (localISTProcessStart === "Invalid date" && localISTProcessEnd === "Invalid date") {
                localISTProcessStart = "Not Process Yet"
                localISTProcessEnd = "Not Process Yet"
            }
              return (
                <tr key={index}>
                  <td>
                    {localIST}
                  </td>
                  <td>
                    {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? <a href="#" onClick={() => this.downloadRCFileResponse(singlercexcelDownloadData.inputfile, 'input', processType)}>{singlercexcelDownloadData.fileOriginalname}</a> : singlercexcelDownloadData.fileOriginalname}
                  </td>
                  {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? <td>{localISTProcessStart}</td> : null}
                  {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? <td>{localISTProcessEnd}</td> : null}
                  <td align="center">{(singlercexcelDownloadData.total_records !== undefined && singlercexcelDownloadData.successful_records !== undefined) ? (singlercexcelDownloadData.successful_records + "/" + singlercexcelDownloadData.total_records) : ""}</td>
                  <td>{singlercexcelDownloadData.outputfile.split('/')[1]}</td>
                  <td>
                    {singlercexcelDownloadData.processing_status === "completed" ?
                      <button className="yellowBtn" onClick={() => this.downloadRCFileResponse(singlercexcelDownloadData.outputfile, "output", processType)}>Download</button> : <button className="process" disabled={"disabled"} >Processing</button>}
                  </td>
                </tr>
              )
            })
            :
            <tr>
              <td colSpan="7" align="center">
                <img src="/assets/images/data-not-found-img.png" width="150" /><br /><br />
                <b style={{ fontSize: 12 }}>No Data Found</b>
              </td>
            </tr>
          }

        </tbody>
      </table>
    </div>
    )
  }

  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN || 
      reactLocalStorage.get("is_have_rcExcel_service") === SERVICE10_TEXT || 
      reactLocalStorage.get("is_have_challanExcel_service") === SERVICE37_TEXT ||
      reactLocalStorage.get("is_have_mobile_rc_excel_service") === SERVICE38_TEXT) {
      return (
        <React.Fragment>
          <div className="wrapper">
            <Header />
            
            <div className="container">
            <div className="noteTextrcexcelList"> Note: You have to wait at least 30 min to complete processing.</div>
              {this.state.isloading == false ?
                <div className="tabSection">
                  <ul className="tabNav">
                    {
                      (reactLocalStorage.get("is_have_rcExcel_service") === SERVICE10_TEXT || reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ? 
                      <li className={(this.state.crTab === 0)?'active':''}><span onClick={() => this.tabClick(0)}>Bulk RC</span></li>
                      : ""
                    }
                    {
                      (reactLocalStorage.get("is_have_challanExcel_service") === SERVICE37_TEXT || reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ?
                      <li className={(this.state.crTab === 1)?'active':''}><span onClick={() => this.tabClick(1)}>Bulk Challan</span></li>
                      :""
                    }
                    {
                      (reactLocalStorage.get("is_have_mobile_rc_excel_service") === SERVICE38_TEXT || reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ?
                      <li className={(this.state.crTab === 2)?'active':''}><span onClick={() => this.tabClick(2)}>Bulk Mobile RC</span></li>
                      :""
                    }
                    
                  </ul>
                  <div className="tabContainer">
                    <div className="tabBlock" style={{'display':`${(this.state.crTab === 0)?'block':'none'}`}}>
                      {this.renderList('RC')}
                    </div>
                    <div className="tabBlock"  style={{'display':`${(this.state.crTab === 1)?'block':'none'}`}}>
                      {this.renderList('CHALLAN')}
                    </div>
                    <div className="tabBlock"  style={{'display':`${(this.state.crTab === 2)?'block':'none'}`}}>
                      {this.renderList('MOBILE')}
                    </div>
                  </div>
                  <br />
                </div>
                :
                <div className="loader" style={{ display: "block" }}>
                  <div className="bg"></div>
                  <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
                </div>
              }
            </div>
          </div>
        </React.Fragment>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}

export default RCExcelList;
